import ContentLoader from 'react-content-loader';

export const CardsLoader = () => {
  return Array.from({ length: 6 }).map((_, index) => (
    <div
      key={`test-${index}`}
      className={`test-${index} col-span-full sm:col-span-6 md:col-span-4`}
    >
      <ContentLoader
        uniqueKey={`test-loader-${index}`}
        id={`test-loader-${index}`}
        speed={2}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        className="size-full rounded-lg md:rounded-xl"
      >
        <rect x="0" y="0" width="100%" height="100%" />
      </ContentLoader>
    </div>
  ));
};
